export const DIRECTORY_MATRIX_ARCHIVE_LABEL = 'Arquivar Matriz:';

export function buildMatrixArchiveTooltip(archived: boolean): string {
  return archived ? 'Desarquivar' : 'Arquivar';
}
